import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EvaluationService {
  static readonly EVALUATION_PERIMETER = 'perimeter';
  static readonly EVALUATION_6MWT = '6mwt';
  static readonly EVALUATION_VISION = 'vision';
  static readonly EVALUATION_DEXTERITY = 'draw';
  static readonly EVALUATION_COGNITION = 'cps';
  static readonly EVALUATION_BLCS = 'blcs';
  static readonly EVALUATION_BWCS = 'bwcs';
  static readonly EVALUATION_MFIS5 = 'mfis5';
  static readonly EVALUATION_PHQ8 = 'phq8';
  static readonly EVALUATION_SF36 = 'sf36';
  static readonly EVALUATION_PS = 'ps';

  constructor() {}
}
